/** Content frame id. Page dialogs position against this box, not the viewport. */
export const APP_SHELL_MAIN_ID = "app-shell-main";

/** Dialog container: the main column when the shell is mounted, otherwise the document body. */
export function appShellDialogContainer() {
  if (typeof document === "undefined") return undefined;
  return document.getElementById(APP_SHELL_MAIN_ID) || document.body;
}
